<template>
  <div>
    <div>
      <b-sidebar
        v-model="visible"
        class="prevent-unselect"
        sidebar-class="h-100 border-left"
        body-class="custom-sidebar"
        bg-variant="white"
        z-index="1000"
        :title="htmlTemplateName"
        :footer-class="['px-3 py-2', {'d-none': !target}]"
        :width="width"
        :right="right"
        no-header-close
        no-close-on-esc
        @change="$emit('toggle')"
      >
        <b-tabs
          v-if="selectedInstance"
          v-model="tabIndex"
          class="no-gutters"
          nav-wrapper-class="layout-sidebar-nav-wrapper"
          content-class="px-3 py-2"
          small
          pills
          vertical
          end
          :nav-class="target ? '' : 'no-target'"
        >
          <b-tab>
            <BannerBuilderEditor 
              :is-open="isOpen"
              :target="backgroundColorRectangle"
              :active-target="target"
              :options="options"
              :themes="themes"
              :type-editor-control="typeEditorControl"
              @toggleSection="toggleSection"
              @update="updateControlEditor"
            />
          </b-tab>
        </b-tabs>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
/* global previews */
import { mapGetters } from 'vuex'
import BannerBuilderEditor from './BannerBuilderEditor.vue';

export default {
  name: 'BannerBuilderLayoutSidebar',
  components: {
    BannerBuilderEditor
  },
  props: {
    isReadOnlyLayout: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    t: 0,
    typeEditorControl: null,
    visible: false,
    defaultTabIndex: 6,
    tabIndex: 6,
    width: '430px',
    right: true,
    target: null,
    themes: null,
    options: {},
    fieldType: '',
    modules: {
      animation: {},
      properties: {},
    },
    isOpen: {
        textEditorFieldsSection: true,
        backgroundFieldsSection: true,
        productImagesFieldsSection: true,
        imagesFieldSection: true,
        aiGenerateFieldsSection: false,
    },
  }),
  
  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
    ]),
    backgroundColorRectangle () {
      if (!this.selectedInstance || !this.selectedInstance.canvas || !this.selectedInstance.canvas.getObjects().length) {
        return null;
      }
      return this.selectedInstance.canvas.getObjects().find(object => object?.fieldType === 'Background Color')
    },
    isReadOnly() {
      return this.isReadOnlyLayout;
    },
    htmlTemplateName() {
      if (this.selectedInstance && this.selectedInstance.id) {
        const templateName = document.querySelector(`.template-item[data-instance="${this.selectedInstance.id}"] > div > div > h2`)?.textContent;
        return templateName || 'No selected item';
        
      } else {
        return 'No selected item';
      }
     
    },
  },
  created() {
    const saved = localStorage.getItem('bannerSectionStates');
    if (saved) {
      try {
        this.isOpen = JSON.parse(saved);
      } catch (e) {
        console.warn('Invalid collapse state JSON', e);
      }
    } else {
      localStorage.setItem('sectionStates', JSON.stringify(this.isOpen));
    }

    if (localStorage.getItem("newSettingsFromAiBannerResizer")) {
      const grid = $("#template-group-preview");
      const customer_id = grid.attr("data-customer-id");
    }
  },
  methods: {
    init(data) {
      this.typeEditorControl = data.typeEditorControl
      this.fieldType = data.fieldType
      this.target = data.target
      this.$store.commit('layout/SET_TARGET', data.target)
      this.options = data.options
      this.modules = data.modules
      this.themes = data.themes
      this.isLayoutInitialized = true;
      window.refreshLayoutSidebar = this.refreshLayoutSidebar;
    },
    refreshLayoutSidebar(data) {
      console.log('refreshLayoutSidebar...');
      this.t = Date.now();
    },
    rerenderLayersModule() {
      this.$nextTick(() => {
        if (!this.$refs.layersModule) return;
        this.$refs.layersModule.rerenderList();
      })
    },
    toggleSection(section) {
      this.isOpen[section] = !this.isOpen[section];
      localStorage.setItem('bannerSectionStates', JSON.stringify(this.isOpen));
    },
    updateControlEditor() {
      this.typeEditorControl = null;
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  $sidebar-offset-top: 160px;
  $sticky-dropdown-height: 45px;

  .b-sidebar {
    top: $sidebar-offset-top;
    max-height: calc(100vh - #{$sidebar-offset-top});

    .custom-sidebar {
      height: 100vh;
      padding-bottom: $sticky-dropdown-height;
    }
  }

  .b-sidebar-header {
    font-size: 1rem;
    overflow-wrap: anywhere;

    strong {
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
    }

    .close {
      order: 2;
      margin-right: 5px !important;
    }
  }

  .no-target {
    .nav-item:not(.instance-related) {
      display: none;
    }
  }

  .layout-sidebar-nav-wrapper {
    display: none;
    position: sticky;
    top: 0;
    align-self: flex-start;
    padding-right: .75rem;
    padding-top: .5rem;

    .nav-link {
      padding: .75rem
    }
  }

  .layer-name-link {
    display: block;
    margin: -0.5rem 0 0.5rem 0;
  }
}
</style>
